import React, { Component } from 'react';
import ImgSliderModal from './components/ImgSliderModal';
import './index.less';

const prefixCls = 'eh-image-viewer';

class ImageViewer extends Component {
	render () {
		return (
			<div className={`${prefixCls}-modal`}>
				<ImgSliderModal
					{...this.props}
					accessibility={false}
				/>
			</div>
		);
	}
}

export default ImageViewer;
